import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map, catchError } from 'rxjs/operators';
import { DateUtility } from '../../../common/utilities/date.utility';
import { ImmigrationDetailsService } from '../../../common/services/immigration-details.service';
import { ProjectsService } from '../../../common/services/projects.service';
import { ProjectTaskService } from '../../../common/services/project-task.service';
import { Store } from '@ngrx/store';
import { getCurrentUser } from 'app/core/store/currentUser/user.selectors';
import { ConsultantModel } from '../../../common/models/consultant.model';
import { ProjectTaskModel } from '../../../common/models/project-task.model';
import { ConsultantProjectRateParameterModel, ConsultantRateModel } from '../../../common/models/consultant-rate.model';
import { commonFunctions } from '../../../common/classes/common.class';
import { ConsultantRateService } from '../../../common/services/consultant-rate.service';
import { SnackbarService } from '../../../common/services/snackbar.service';
import { Constants } from '../../../common/utilities/constants.config';
import { CurrencyModel } from '../../../common/models/currency.model';
import { ExpensePaymentMethodModel } from '../../../common/models/expense-payment-method.model';
import { ExpenseTypeModel, ExpenseTypeDescriptionModel } from '../../../common/models/expense-type.model';
import { ExpenseTypeService } from '../../../common/services/expense-type.service';
import { ExpenseEntryService } from 'app/core/mips/common/services/expense-entry.service';
import { ExpensePaymentMethodService } from '../../../common/services/expense-payment-method.service';
import { CurrencyService } from '../../../common/services/currency.service';
import { getImmigrationDetails } from 'app/core/store/immigrationDetails/immigrationDetails.selector';
// Add these imports for your project's services
import { ApiheaderService } from '../../../common/services/apiheader.service';
import { SessionStorageService } from '../../../common/services/session-storage.service';
import { ErrorHandlerService } from '../../../common/services/error-handler.service';
import { URLPaths } from 'app/core/mips/common/utilities/urlPaths.config';
import { SustainabilityEntryService } from 'app/core/mips/common/services/sustainability-entry.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs';
import { TransportModeService } from 'app/core/mips/common/services/transport-modes.service';
// Add airport model interface
interface AirportModel {
  name: string;
  iata_code: string;
  airport_desc: string;
}

@Component({
  selector: 'app-entry-dialog',
  templateUrl: './entry-dialog.component.html',
  styleUrls: ['./entry-dialog.component.scss'],
})
export class EntryDialogComponent implements OnInit {
  transportModes: any[] = [];
  filteredModes: any[] = [];

  entryForm: FormGroup;
  currentUser: ConsultantModel;
  projectList: any[] = [];
  selectedProject: any;
  projectTaskList: ProjectTaskModel[] = [];
  selectedProjectTask: any;
  consultantProjectRate: ConsultantRateModel[] = [];
  selectedConsultantRate: ConsultantRateModel;
  consulantProjectClientRate: ConsultantRateModel;
  expenseTypeList: ExpenseTypeModel[] = [];
  selectedExpenseType: ExpenseTypeModel;
  expenseTypeDescList: ExpenseTypeDescriptionModel[] = [];
  selectedExpenseDescType: ExpenseTypeDescriptionModel;
  paymentMethodList: ExpensePaymentMethodModel[] = [];
  selectedPaymentMethod: ExpensePaymentMethodModel;
  currencyList: CurrencyModel[] = [];
  selectedCurrency: CurrencyModel;

  // New airport-related properties
  airportList: AirportModel[] = [];
  selectedFromAirport: string;
  selectedToAirport: string;
  selectedLayoverAirport1: string;
  selectedLayoverAirport2: string;
  layoverCount: number = 0;


  visible = true;
  isChargeable = false;
  isEntryCreateMode = true;
  hourChoice = 'Hour';
  consultantWorkHour = null;
  invoiceOnSameDate = true;
  consultantImmigrationDetails: any;
  consultantWorkCountry = null;
  projectCurrency: string;
  showVatFields: boolean = false;
  readonly VAT_RATES = {
    '£': (1/6),  // UK VAT rate
    'S$': (9/109)    // Singapore VAT rate
  };
  vatRate: number = 0;
previousAmount: number = 0;
isVatManuallyEdited: boolean = false;
readonly FINANCE_EXPENSE_URL = '/mips/core/finance-expense';
hideCloneButton = false;
  selectedTaxiMode: any = null;
  selectedTrainMode: any = null;

  // Transport mode properties
  selectedTransportType: any = null;
  distance: number = 0;
  distanceUnit: string = '';


  constructor(
    private dialogRef: MatDialogRef<EntryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private _formBuilder: FormBuilder,
    private transportModeService: TransportModeService,
    private consultantImmigrationDetailsService: ImmigrationDetailsService,
    private projectService: ProjectsService,
    private projectTaskService: ProjectTaskService,
    private consultantRateService: ConsultantRateService,
    private snackBarService: SnackbarService,
    private ExpenseEntryService: ExpenseEntryService,
    private _store: Store,
    private expenseTypeService: ExpenseTypeService,
    private expensePaymentMethodService: ExpensePaymentMethodService,
    private SustainabilityEntryService: SustainabilityEntryService,
    private currencyService: CurrencyService,
    // Add these services when you're ready to use the actual API:
    private _http: HttpClient,
    private _errorHandlerService: ErrorHandlerService
  ) {
    this._store.select(getCurrentUser).subscribe((data) => {
      this.currentUser = data;
    });
  //   this._store.select(getCurrentUser).subscribe((user) => {
  //     this.showVatFields = user?.Country_Name === 'UK' || user?.Country_Name === 'SG';
  // });
    // this.getProjects();
    this._store
      .select(getImmigrationDetails)
      .subscribe((immigrationDetails) => {
        this.consultantImmigrationDetails = immigrationDetails;
        this.consultantWorkCountry =
          this.consultantImmigrationDetails['consultantWorkCountry'];
        this.consultantWorkHour =
          this.consultantImmigrationDetails['consultantWorkHour'];
      });

    if (this.dialogData.Mode === 'edit') {
      this.isEntryCreateMode = false;
      if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
        this.isChargeable = this.dialogData.Charge.toLowerCase() === 'yes';
      }
    }

    if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      this.entryForm = this._formBuilder.group({
        Time_ID: [this.dialogData.Time_ID],
        Project: [this.dialogData.Project, Validators.required],
        ProjectName: [this.dialogData.ProjectName],
        ClientName: [this.dialogData.ClientName],
        Client: [this.dialogData.Client],
        Cost: [this.dialogData.Cost],
        Days: [this.dialogData.Days],
        Task_Description: [
          this.dialogData.Task_Description,
          Validators.required,
        ],
        Hours: [this.dialogData.Hours, Validators.required],
        Task_Code: [this.dialogData.Task_Name],
        Task_Name: [this.dialogData.Task_Description, Validators.required],
        Rate: [this.dialogData.Rate, Validators.required],
        TDate: [this.dialogData.TDate, Validators.required],
        Invoice_Date: [this.dialogData.Invoice_Date, Validators.required],
        Invoice_id: [this.dialogData.Invoice_id],
        Charge: [this.isChargeable, Validators.required],
        Task_id: [this.dialogData.Task_id],
        Currency_Code: [this.dialogData.Currency_Code],
        Currency_symbol_short: [this.dialogData.Currency_symbol_short],
        Employee: [this.dialogData.Employee],
        Copy: [true],
        Contact: [this.dialogData.Contact],
        Version: [this.dialogData.Version],
        ApplyTo: [this.dialogData.ApplyTo],
        Employee_FullName: [this.dialogData.Employee_FullName],
        Year: [this.dialogData.Year],
        Month: [this.dialogData.Month],
        Week_Commencing: [this.dialogData.Week_Commencing],
        Company_Name: [this.dialogData.Company_Name],
        Consultant_Company_Name: [this.dialogData.Consultant_Company_Name],

      });
      if (this.dialogData.TDate !== this.dialogData.Invoice_Date) {
        this.invoiceOnSameDate = false;
      }
    } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {

      this.entryForm = this._formBuilder.group({
        ExpenseID: [this.dialogData.ExpenseID],
        AmountSpent: [
          this.dialogData.AmountSpent,
          EntryDialogComponent.AmountRangeValidator,
        ],
        AmountConstant: [this.dialogData.Amount_Constant],
        AmountNative: [this.dialogData.Amount_Native],
        ClientName: [this.dialogData.ClientName],
        Client: [this.dialogData.Client],
        Company_id: [this.dialogData.Company_id],
        Currency_To: [this.dialogData.Currency_To],
        Currency_symbol: [this.dialogData.Currency_symbol],
        Currency_symbol_short: [
          this.dialogData.Currency_symbol_short,
          Validators.required,
        ],
        Currency_symbol_short_to: [this.dialogData.Currency_symbol_short_to],
        Currency_From: [this.dialogData.Currency_From],
        Description: [this.dialogData.Description, Validators.required],
        Details: [this.dialogData.Details, Validators.required],
        Employee: [this.dialogData.Employee],
        ExpenseType: [this.dialogData.ExpenseType, Validators.required],
        isVatApplicable: [this.dialogData.Mode === 'edit' && this.dialogData.Tax_Amount > 0],
        Tax_Amount: [{
          value: this.dialogData.Mode === 'edit' ? this.dialogData.Tax_Amount : 0,
          disabled: !(this.dialogData.Mode === 'edit' && this.dialogData.Tax_Amount > 0)
        }],
        TDate: [this.dialogData.TDate, Validators.required],
        Invoice_date: [this.dialogData.Invoice_date],
        travel_id: [this.dialogData.travel_id || null],
        Invoice_id: [this.dialogData.Invoice_id],
        Distance: [this.dialogData.Distance ?? this.dialogData.distance ?? null],
        DistanceUnit: [this.dialogData.DistanceUnit ?? this.dialogData.distance_unit ?? null],
        TransportType: [this.dialogData.TransportType ?? this.dialogData.transport_mode_id ?? this.dialogData.transportmode_id ?? null],
        LoginName: [this.dialogData.LoginName],
        // Mileage: [this.dialogData.Mileage],
        MileageRate: [this.dialogData.MileageRate],
        Mode: [this.dialogData.Mode],
        PaymentMethod: [this.dialogData.PaymentMethod, Validators.required],
        Period_Month: [this.dialogData.Period_Month || ''],
        Period_Year: [this.dialogData.Period_Year || ''],
        Project: [this.dialogData.Project, Validators.required],
        Project_Description: [this.dialogData.ProjectName],
        Project_Sales_Tax: null,
        State_code: [this.dialogData.State_code],
        State_Name: [this.dialogData.State_Name],
        State_id: [this.dialogData.State_id],
        Task_Name: [this.dialogData.Task_Name, Validators.required],
        Task_Description: [this.dialogData.Task_Description],
        Task_id: [this.dialogData.Task_id],
        Version_id: [this.dialogData.Version_id],
        status: [this.dialogData.status],
        Copy: [false],
        // New airport fields
        FromAirport: [this.dialogData.FromAirport],
        ToAirport: [this.dialogData.ToAirport],
        LayoverAirport1: [this.dialogData.LayoverAirport1],  // Updated
        LayoverAirport2: [this.dialogData.LayoverAirport2],  // New
        LayoverCount: [this.dialogData.LayoverCount || 0],
        // RoundTrip: [this.dialogData.RoundTrip || false]  // Round trip checkbox
        RoundTrip: [
          this.dialogData?.RoundTrip ?? (Number(this.dialogData?.is_roundtrip ?? 0) === 1)
        ]

      },
      {
        validators: [this.differentAirportsValidator,   // From vs To
        this.layoversDifferentValidator]
      }
    );

      if (this.dialogData.TDate !== this.dialogData.Invoice_date) {
        this.invoiceOnSameDate = false;
      }

      this.getExpenseType(this.dialogData.Client, this.dialogData.Project);
      this.getPaymentMethod();
      this.getCurrency(this.dialogData.Client, this.dialogData.Project);
      this.entryForm.get('AmountSpent').valueChanges.subscribe(value => {
        if (!this.isVatManuallyEdited && this.entryForm.get('isVatApplicable').value) {
          this.calculateAndSetVat(value);
        }
        this.previousAmount = value;
      });
      this.entryForm.get('Tax_Amount').valueChanges.subscribe(() => {
        this.isVatManuallyEdited = true;
      });
      this.entryForm.get('Currency_symbol_short').valueChanges.subscribe((newCurrency) => {
        if (this.dialogData.Mode === 'edit') {
          // Check if it's actually a currency change by comparing with previous value
          if (this.selectedCurrency && this.selectedCurrency.currency_symbol_short !== newCurrency.currency_symbol_short) {
            // Only turn off VAT when currency actually changes
            this.entryForm.get('isVatApplicable').setValue(false);
            this.entryForm.get('Tax_Amount').setValue(null);
            this.isVatManuallyEdited = false;
          }
        } else {
          // Original behavior for non-edit mode
          this.entryForm.get('isVatApplicable').setValue(false);
          this.entryForm.get('Tax_Amount').setValue(null);
          this.isVatManuallyEdited = false;
        }
      });

      this.entryForm.get('Currency_symbol_short').valueChanges.subscribe((newCurrency: any) => {
        this.selectedCurrency = newCurrency;

        if (newCurrency && newCurrency.currency_symbol) {
          const validCountries = ['UK', 'SG'];

          // Check if we're on the finance expense page
          const isFinanceExpensePage = window.location.href.includes(this.FINANCE_EXPENSE_URL);
          this.hideCloneButton = !isFinanceExpensePage;


          if (isFinanceExpensePage) {
            // On finance page, show VAT fields for either currency if user is from UK or SG
            if (validCountries.includes(this.currentUser?.Country_Name)) {
              const symbol = newCurrency.currency_symbol;
              const vatRate = this.VAT_RATES[symbol];
              this.showVatFields = vatRate !== undefined;

              if (this.showVatFields) {
                this.vatRate = vatRate;
                this.entryForm.get('isVatApplicable').enable();
              } else {
                this.vatRate = 0;
                this.entryForm.get('isVatApplicable').setValue(false);
                this.entryForm.get('Tax_Amount').setValue(null);
                this.entryForm.get('isVatApplicable').disable();
              }
            } else {
              // Not UK/SG user - hide VAT fields
              this.showVatFields = false;
              this.vatRate = 0;
              this.entryForm.get('isVatApplicable').setValue(false);
              this.entryForm.get('Tax_Amount').setValue(null);
              this.entryForm.get('isVatApplicable').disable();
            }
          } else {
            // Original strict validation for non-finance pages
            if (!validCountries.includes(this.currentUser?.Country_Name)) {
              this.showVatFields = false;
              this.vatRate = 0;
              this.entryForm.get('isVatApplicable').setValue(false);
              this.entryForm.get('Tax_Amount').setValue(null);
              this.entryForm.get('isVatApplicable').disable();
              return;
            }
            const isValidVatCombination = (
              (this.currentUser?.Country_Name === 'UK' && newCurrency.currency_symbol === '£') ||
              (this.currentUser?.Country_Name === 'SG' && newCurrency.currency_symbol === 'S$')
            );
            this.showVatFields = isValidVatCombination;
          }

          // Common logic for edit mode and calculations
          if (this.showVatFields) {
            if (this.dialogData.Mode === 'edit' && this.dialogData.Tax_Amount > 0) {
              this.entryForm.get('Tax_Amount').enable();
              this.entryForm.get('isVatApplicable').setValue(true);
              this.entryForm.get('Tax_Amount').setValue(this.dialogData.Tax_Amount);
              this.isVatManuallyEdited = true;
            } else if (this.entryForm.get('isVatApplicable').value) {
              const currentAmount = this.entryForm.get('AmountSpent').value;
              if (currentAmount) {
                this.calculateAndSetVat(currentAmount);
              }
            }
          }
        }
      });
      this.getProjects();
    // this.getProjectTask(this.dialogData.Client, this.dialogData.Project);
  }
  }
  private calculateAndSetVat(amount: number): void {

    if (!amount || isNaN(amount)) return;
    if (this.dialogData.Mode === 'edit' && this.entryForm.get('Tax_Amount').value) {

      return;
    }

    const currencySymbol = this.selectedCurrency?.currency_symbol;
    if (!currencySymbol) return;

    const vatRate = this.VAT_RATES[currencySymbol];
    if (vatRate) {
      const vatAmount = (amount * vatRate);

      this.entryForm.get('Tax_Amount').setValue(vatAmount.toFixed(2), { emitEvent: false });

      // Initialize airport data for editing mode or pre-filled unsaved mode
      if (this.dialogData.Description === 'Plane Travel') {
        this.layoverCount = this.dialogData.LayoverCount || 0;
        this.selectedFromAirport = this.dialogData.FromAirport;
        this.selectedToAirport = this.dialogData.ToAirport;
        this.selectedLayoverAirport1 = this.dialogData.LayoverAirport1;
        this.selectedLayoverAirport2 = this.dialogData.LayoverAirport2;
        this.getAirports();
      }
    }
  }
  isTaxiOrTrainSelected(): boolean {
    const mode = this.entryForm.get('Mode')?.value;
    return mode === 'Taxi' || mode === 'Train';
  }
  onDescriptionChange(desc: string) {
    const distanceControl = this.entryForm.get('Distance');
    const unitControl = this.entryForm.get('DistanceUnit');
    const typeControl = this.entryForm.get('TransportType');

    // Reset travel_id when description changes to prevent mismatched sustainability entries
    // This ensures dragged entries don't inherit travel_id from a different type
    // this.entryForm.patchValue({ travel_id: 0 }, { emitEvent: false });
    // Only reset travel_id if this is NOT edit mode
    const isEdit = this.dialogData?.Mode === 'edit';

    if (!isEdit) {
      this.entryForm.patchValue({ travel_id: 0 }, { emitEvent: false });
    }

    if (desc === 'Mileage' || desc === 'Motor Vehicle Hire' || desc === 'Train Travel' || desc === 'Train/Bus Travel' || desc === 'Taxi Travel'|| desc === 'Taxi travel') {
      distanceControl?.setValidators([Validators.required]);
      unitControl?.setValidators([Validators.required]);
      typeControl?.setValidators([Validators.required]);
    } else {
      distanceControl?.clearValidators();
      unitControl?.clearValidators();
      typeControl?.clearValidators();
    }

    distanceControl?.updateValueAndValidity();
    unitControl?.updateValueAndValidity();
    typeControl?.updateValueAndValidity();
  }
  layoversDifferentValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const from = control.get('FromAirport')?.value;
    const to = control.get('ToAirport')?.value;
    const layover1 = control.get('LayoverAirport1')?.value;
    const layover2 = control.get('LayoverAirport2')?.value;
    const descValue = control.get('Description')?.value;
    const desc = (descValue && typeof descValue === 'object') ? descValue.description : descValue;

    if (desc === 'Plane Travel') {
      if (layover1) {
        if (layover1 === from) return { layover1SameAsFrom: true };
        if (layover1 === to) return { layover1SameAsTo: true };
      }
      if (layover2) {
        if (layover2 === from) return { layover2SameAsFrom: true };
        if (layover2 === to) return { layover2SameAsTo: true };
      }
      if (layover1 && layover2 && layover1 === layover2) {
        return { sameLayovers: true };
      }
    }
    return null;
  };



  onModeChange(mode: string) {
    const distanceControl = this.entryForm.get('Distance');
    const unitControl = this.entryForm.get('DistanceUnit');
    const typeControl = this.entryForm.get('TransportType');

    if (mode === 'Taxi' || mode === 'Train') {
      distanceControl?.setValidators([Validators.required]);
      unitControl?.setValidators([Validators.required]);
      typeControl?.setValidators([Validators.required]);
    } else {
      distanceControl?.clearValidators();
      unitControl?.clearValidators();
      typeControl?.clearValidators();
    }

    distanceControl?.updateValueAndValidity();
    unitControl?.updateValueAndValidity();
    typeControl?.updateValueAndValidity();
  }
  // ngOnInit(): void {
  //   // fetch transport modes
  //   this.transportModeService.getTransportModes().subscribe({
  //     next: (modes) => {
  //       this.transportModes = modes;

  //       // **NEW: Filter modes based on allowedTransportModeIds from parent**
  //       if (this.dialogData.allowedTransportModeIds && this.dialogData.allowedTransportModeIds.length > 0) {
  //         this.filteredModes = modes.filter(mode => 
  //           this.dialogData.allowedTransportModeIds.includes(mode.transportmode_id)
  //         );
  //       } else {
  //         this.filteredModes = modes;
  //       }

  //       if (!this.isEntryCreateMode && this.dialogData.transportmode_desc) {
  //         const matchingMode = this.transportModes.find(
  //           mode => mode.transportmode_desc === this.dialogData.transportmode_desc
  //         );
  //         if (matchingMode) {
  //           this.entryForm.get('TransportType')?.setValue(matchingMode.transportmode_id);
  //         }
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error fetching transport modes', err);
  //     }
  //   });

  //   this.entryForm.get('Description')?.valueChanges.subscribe((desc) => {
  //     this.onDescriptionChange(desc);
  //   });

  //   // call work country logic
  //   this.getWorkCountry();
  // }
  ngOnInit(): void {
    // 1. Fetch transport modes
    this.transportModeService.getTransportModes().subscribe({
      next: (modes) => {
        this.transportModes = modes;

        // Determine current description for filtering
        const currentDesc = this.dialogData.Description;

        // 2. Filter modes based on description (Handles vehicle, taxi and train variants)
        if (currentDesc === 'Mileage' || currentDesc === 'Motor Vehicle Hire') {
          this.filteredModes = modes.filter(mode =>
            [1, 3, 10, 11].includes(mode.transportmode_id)
          );
        } else if (currentDesc === 'Taxi Travel' || currentDesc === 'Taxi travel') {
          this.filteredModes = modes.filter(mode =>
            [12].includes(mode.transportmode_id)
          );
        } else if (currentDesc === 'Train Travel') {
          this.filteredModes = modes.filter(mode =>
            [2, 7].includes(mode.transportmode_id)
          );
        } else if (currentDesc === 'Train/Bus Travel') {
          this.filteredModes = modes.filter(mode =>
            [2, 7, 8].includes(mode.transportmode_id)
          );
        } else if (this.dialogData.allowedTransportModeIds && this.dialogData.allowedTransportModeIds.length > 0) {
          this.filteredModes = modes.filter(mode =>
            this.dialogData.allowedTransportModeIds.includes(mode.transportmode_id)
          );
        } else {
          this.filteredModes = modes;
        }
        this.autoSelectIfSingleOption();

        // 3. Pre-load data in Edit Mode OR for dragged CREATE entries
        // 3. Pre-load data for ALL rows (Saved, Unsaved, DragCopied) securely
        const savedModeId = this.dialogData.transport_mode_id ?? this.dialogData.transportmode_id ?? this.dialogData.TransportType ?? null;

        if (savedModeId) {
          this.entryForm.get('TransportType')?.setValue(savedModeId);
        } else if (this.dialogData.transportmode_desc) {
          // Fallback to string matching if ID is missing
          const matchingMode = this.transportModes.find(
            mode => mode.transportmode_desc === this.dialogData.transportmode_desc
          );
          if (matchingMode) {
            this.entryForm.get('TransportType')?.setValue(matchingMode.transportmode_id);
          }
        }
      },
      error: (err) => {
        console.error('Error fetching transport modes', err);
      }
    });
    // Watch for description changes to update validators/filters dynamically
    this.entryForm.get('Description')?.valueChanges.subscribe((desc) => {
      this.onDescriptionChange(desc);
    });
    this.getProjects();
    this.getProjectTask(this.dialogData.Client, this.dialogData.Project);
    this.getWorkCountry();
  }

  autoSelectIfSingleOption(): void {
    const control = this.entryForm.get('TransportType');
    if (this.filteredModes.length === 1 && !control?.value) {
      control?.setValue(this.filteredModes[0].transportmode_id);
    }
  }

  static AmountRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    if (
      control.value !== undefined &&
      (isNaN(control.value) ||
        control.value === 0 ||
        commonFunctions.isNullOrUndefined(control.value))
    ) {
      return { AmountRange: true };
    }

    return null;
  }

  // New method to get airports
  getAirports(): void {
    const params = new HttpParams();
    this._http.get(URLPaths.URL_AIRPORTS, { headers: ApiheaderService.getHeaders(), params: params })
      .pipe(
        map(res => {
          const list = (res as AirportModel[]) || [];
          this.airportList = list.sort((a, b) =>
            (a.airport_desc || a.iata_code || '').localeCompare(b.airport_desc || b.iata_code || '')
          );
          SessionStorageService.setSessionStorageValueBasedOnKey('Airports_List', JSON.stringify(this.airportList));

          // Handle pre-selection for existing or copied/dragged data
          if (this.dialogData.Description === 'Plane Travel') {
            this.selectedFromAirport = this.dialogData.FromAirport;
            this.selectedToAirport = this.dialogData.ToAirport;

            // Handle multiple layovers
            if (this.dialogData.LayoverCount > 0) {
              this.layoverCount = this.dialogData.LayoverCount;

              if (this.layoverCount >= 1) {
                this.selectedLayoverAirport1 = this.dialogData.LayoverAirport1;
              }

              if (this.layoverCount === 2) {
                this.selectedLayoverAirport2 = this.dialogData.LayoverAirport2;
              }
            }
          }
          return res;
        }),
        catchError(this._errorHandlerService.handleError.bind(this))
      ).subscribe();
  }

  setInputFieldStatus(hourChoice: string): void {
    this.hourChoice = hourChoice;
    if (this.hourChoice === 'Half') {
      this.entryForm.controls['Hours'].disable();
      this.entryForm.controls['Hours'].setValue(
        Number(this.consultantWorkHour) / 2
      );
    } else if (this.hourChoice === 'Full') {
      this.entryForm.controls['Hours'].disable();
      this.entryForm.controls['Hours'].setValue(this.consultantWorkHour);
    } else {
      this.entryForm.controls['Hours'].enable();
    }
  }

  getWorkCountry(): void {
    if (this.hourChoice === 'Half') {
      this.entryForm.controls['Hours'].setValue(Number(this.consultantWorkHour) / 2);
    } else if (this.hourChoice === 'Full') {
      this.entryForm.controls['Hours'].setValue(this.consultantWorkHour);
    }
  }

  // getProjects(): void {
  //   this.projectService.getProjects(false, this.currentUser['Employee'], this.dialogData.startDate, this.dialogData.endDate).subscribe(projectList => {
  //     this.projectList = projectList;
  //     if (!this.isEntryCreateMode) {
  //       this.selectedProject = this.projectList.filter(project => {
  //         return project.Project.toLowerCase() === this.dialogData.Project.toLowerCase() && project.Client.toLowerCase() === this.dialogData.Client.toLowerCase();
  //       })[0];
  //       this.getConsultantProjectRate(this.dialogData.Client, this.dialogData.Project);
  //     }
  //   });
  // }
  getProjects(): void {
    this.projectService
      .getProjects(false, this.currentUser['Employee'], this.dialogData.startDate, this.dialogData.endDate)
      .subscribe(projectList => {
        this.projectList = projectList;

        // Always resolve selectedProject (even in create mode)
        const proj = this.dialogData?.Project;
        const client = this.dialogData?.Client;

        if (proj && client) {
          this.selectedProject = this.projectList.find(p =>
            String(p.Project).toLowerCase() === String(proj).toLowerCase() &&
            String(p.Client).toLowerCase() === String(client).toLowerCase()
          );
        }
        if (
          !this.isEntryCreateMode &&
          this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS
        ) {
          this.getConsultantProjectRate(this.dialogData.Client, this.dialogData.Project);
        }
      });
  }

  getProjectTask(client, project): void {
    this.projectTaskList = [];
    if (!commonFunctions.isNullOrUndefined(client) && !commonFunctions.isNullOrUndefined(project)) {
      this.projectTaskService.getProjectTasks(client, project).subscribe(projectTasks => {
        this.projectTaskList = projectTasks;

        this.selectedProjectTask = this.projectTaskList.filter(task => {
          return task.Task_id === this.dialogData.Task_id;
        })[0];
        if (commonFunctions.isNullOrUndefined(this.selectedProjectTask) && this.projectTaskList.length === 1) {
          this.selectedProjectTask = this.projectTaskList[0];
        }
      });
    }
  }

  changeInvoiceDate(): void {
    if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      this.entryForm.value.Invoice_Date = DateUtility.formatStringfromDate(
        this.entryForm.value.Invoice_Date.toDate()
      );
    } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
      this.entryForm.value.Invoice_date = DateUtility.formatStringfromDate(
        this.entryForm.value.Invoice_date.toDate()
      );
    }
  }

  changeTDate(): void {
    if (typeof this.entryForm.value.TDate === 'object') {
      this.entryForm.value.TDate = DateUtility.formatStringfromDate(
        this.entryForm.value.TDate.toDate()
      );
    }
    if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      this.selectedConsultantRate = null;
      if (!commonFunctions.isNullOrUndefined(this.selectedProject)) {
        this.getConsultantProjectRate(
          this.selectedProject.Client,
          this.selectedProject.Project
        );
      }
    }
    this.getWorkCountry();
  }

  getConsultantProjectRate(client, project): void {
    const consultantClientProjectRate = new ConsultantProjectRateParameterModel();

    if (typeof this.entryForm.value.TDate === 'object') {
      this.entryForm.value.TDate = DateUtility.formatStringfromDate(
        this.entryForm.value.TDate.toDate()
      );
    }
    const entryDate = DateUtility.createDateTypefromDate(
      this.entryForm.value.TDate.substr(0, 10)
    );
    consultantClientProjectRate.employee = this.currentUser.Employee;
    consultantClientProjectRate.client = client;
    consultantClientProjectRate.project = project;
    consultantClientProjectRate.entrydate =
      String(entryDate.getFullYear()) +
      String(
        (Number(entryDate.getMonth()) + 1 < 10 ? '0' : '') +
          (Number(entryDate.getMonth()) + 1)
      );
    this.consultantRateService
      .getConsultantByProject(consultantClientProjectRate)
      .subscribe((consultantRate) => {
        this.consultantProjectRate = consultantRate;
        this.selectedConsultantRate = this.consultantProjectRate.filter(
          (rate) => {
            return (
              rate.Client === this.selectedProject.Client &&
              rate.Project === this.selectedProject.Project
            );
          }
        )[0];
        if (commonFunctions.isNullOrUndefined(this.selectedConsultantRate)) {
          this.selectedConsultantRate = this.consultantProjectRate.filter(
            (rates) => rates.Is_Default_Rate === 1
          )[0];
        }
      });
  }

  onChangeSelectedProject(params): void {
    if (!commonFunctions.isNullOrUndefined(params)) {
      this.selectedProjectTask = null;
      this.selectedProject = this.projectList.filter((project) => {
        return (
          project.Project === params.Project && project.Client === params.Client
        );
      })[0];

      this.getProjectTask(params.Client, params.Project);

      if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
        this.selectedConsultantRate = null;
        this.getConsultantProjectRate(params.Client, params.Project);
        if (this.selectedProject.Charge.toLowerCase() === 'yes') {
          this.isChargeable = true;
        } else {
          this.isChargeable = false;
        }
      } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
        this.selectedExpenseType = null;
        this.selectedExpenseDescType = null;
        this.selectedPaymentMethod = null;
        this.selectedCurrency = null;
        // this.entryForm.controls['Mileage'].setValue(this.selectedProject.DefaultMileage);
        this.getExpenseType(params.Client, params.Project);
        this.getPaymentMethod();
        this.getCurrency(params.Client, params.Project);
      }
    }
  }

  onChangeSelectedType(params): void {
    if (!commonFunctions.isNullOrUndefined(params)) {
      this.selectedExpenseDescType = null;
      // Reset airport fields when changing expense type
      this.resetAirportFields();
      this.getExpenseTypeDesc(params.Type);
    }
  }

  onChangeSelectedDescription(params): void {
    if (!params) return;

    this.selectedExpenseDescType = params;

    // Store the current TransportType value before resetting (for dragged entries)
    const savedTransportTypeId = this.entryForm.get('TransportType')?.value;

    // --- Reset defaults before applying new rules ---
    // this.resetAirportFields();
    // this.resetTransportFields();   
    // Only reset if we are creating a NEW entry.
    // If we are EDITING, do NOT call reset, or we lose the preloaded data!
    if (this.isEntryCreateMode && !this.dialogData?.__createdFromDragCopy) {
      this.resetAirportFields();
      this.resetTransportFields();
    }

    // Force RoundTrip to false if not Plane Travel
    if (params.description !== 'Plane Travel') {
      this.entryForm.controls['RoundTrip'].setValue(false);
    }

    this.entryForm.controls['FromAirport'].clearValidators();
    this.entryForm.controls['ToAirport'].clearValidators();
    this.entryForm.controls['LayoverAirport1'].clearValidators();
    this.entryForm.controls['LayoverAirport2'].clearValidators();
    this.entryForm.controls['TransportType'].clearValidators();
    this.entryForm.controls['Distance'].clearValidators();
    this.entryForm.controls['DistanceUnit'].clearValidators();

    if (params.description === 'Plane Travel') {
      // Load airports
      this.getAirports();

      // Apply airport validators
      this.entryForm.controls['FromAirport'].setValidators([Validators.required]);
      this.entryForm.controls['ToAirport'].setValidators([Validators.required]);
      this.entryForm.controls['LayoverAirport1'].setValidators([]);
      this.entryForm.controls['LayoverAirport2'].setValidators([]);

    } else if (params.description === 'Mileage' || params.description === 'Motor Vehicle Hire') {
      // Filter vehicle transport modes (cars)
      this.filteredModes = this.transportModes.filter(mode =>
        [1, 3, 10, 11].includes(mode.transportmode_id)
      );

      // Apply vehicle-related validators (Mileage, Motor Vehicle Hire)
      this.entryForm.controls['TransportType'].setValidators([Validators.required]);
      this.entryForm.controls['Distance'].setValidators([Validators.required, Validators.min(1)]);
      this.entryForm.controls['DistanceUnit'].setValidators([Validators.required]);

      // Restore preloaded transport mode if it exists and is valid for this description
      if (savedTransportTypeId && this.filteredModes.some(m => m.transportmode_id === savedTransportTypeId)) {
        this.entryForm.get('TransportType')?.setValue(savedTransportTypeId);
      }

    } else if (params.description === 'Taxi Travel' || params.description === 'Taxi travel') {
      // Filter taxi transport modes (taxi specific id)
      this.filteredModes = this.transportModes.filter(mode =>
        [12].includes(mode.transportmode_id)
      );

      // Apply taxi validators
      this.entryForm.controls['TransportType'].setValidators([Validators.required]);
      this.entryForm.controls['Distance'].setValidators([Validators.required, Validators.min(1)]);
      this.entryForm.controls['DistanceUnit'].setValidators([Validators.required]);

      // Restore preloaded transport mode if it exists and is valid for this description
      if (savedTransportTypeId && this.filteredModes.some(m => m.transportmode_id === savedTransportTypeId)) {
        this.entryForm.get('TransportType')?.setValue(savedTransportTypeId);
      }
      
        this.autoSelectIfSingleOption();

    } else if (params.description === 'Train Travel') {
      // Filter Train transport modes
      this.filteredModes = this.transportModes.filter(mode =>
        [2, 7].includes(mode.transportmode_id)
      );

      // Apply Train validators
      this.entryForm.controls['TransportType'].setValidators([Validators.required]);
      this.entryForm.controls['Distance'].setValidators([Validators.required, Validators.min(1)]);
      this.entryForm.controls['DistanceUnit'].setValidators([Validators.required]);

      // Restore preloaded transport mode if it exists and is valid for this description
      if (savedTransportTypeId && this.filteredModes.some(m => m.transportmode_id === savedTransportTypeId)) {
        this.entryForm.get('TransportType')?.setValue(savedTransportTypeId);
      }

    } else if (params.description === 'Train/Bus Travel') {
      // Filter Train/Bus transport modes
      this.filteredModes = this.transportModes.filter(mode =>
        [2, 7, 8].includes(mode.transportmode_id)
      );

      // Apply Train/Bus validators
      this.entryForm.controls['TransportType'].setValidators([Validators.required]);
      this.entryForm.controls['Distance'].setValidators([Validators.required, Validators.min(1)]);
      this.entryForm.controls['DistanceUnit'].setValidators([Validators.required]);

      // Restore preloaded transport mode if it exists and is valid for this description
      if (savedTransportTypeId && this.filteredModes.some(m => m.transportmode_id === savedTransportTypeId)) {
        this.entryForm.get('TransportType')?.setValue(savedTransportTypeId);
      }
    }

    // --- Refresh validity ---
    this.entryForm.controls['FromAirport'].updateValueAndValidity();
    this.entryForm.controls['ToAirport'].updateValueAndValidity();
    this.entryForm.controls['LayoverAirport1'].updateValueAndValidity();
    this.entryForm.controls['LayoverAirport2'].updateValueAndValidity();
    this.entryForm.controls['TransportType'].updateValueAndValidity();
    this.entryForm.controls['Distance'].updateValueAndValidity();
    this.entryForm.controls['DistanceUnit'].updateValueAndValidity();
  }
  resetTransportFields(): void {
    this.entryForm.controls['TransportType'].setValue(null);
    this.entryForm.controls['Distance'].setValue(null);
    this.entryForm.controls['DistanceUnit'].setValue(null);

    this.selectedTaxiMode = null;
    this.selectedTrainMode = null;
  }

  // New method to reset airport fields
  resetAirportFields(): void {
    this.selectedFromAirport = null;
    this.selectedToAirport = null;
    this.selectedLayoverAirport1 = null;
    this.selectedLayoverAirport2 = null;
    this.layoverCount = 0;
    this.entryForm.controls['FromAirport'].setValue(null);
    this.entryForm.controls['ToAirport'].setValue(null);
    this.entryForm.controls['LayoverAirport1'].setValue(null);
    this.entryForm.controls['LayoverAirport2'].setValue(null);
    this.entryForm.controls['LayoverCount'].setValue(0);
  }
  // Custom validator: FromAirport and ToAirport should not be the same
  differentAirportsValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const from = group.get('FromAirport')?.value;
    const to = group.get('ToAirport')?.value;

    if (from && to && from === to) {
      return { sameAirport: true };
    }
    return null;
  }


  // New method to toggle layover
  addLayover(): void {
    if (this.layoverCount < 2) {
      this.layoverCount++;
      this.entryForm.controls['LayoverCount'].setValue(this.layoverCount);

      if (this.layoverCount >= 1) {
        this.entryForm.controls['LayoverAirport1'].setValidators([Validators.required]);
        this.entryForm.controls['LayoverAirport1'].updateValueAndValidity();
      }
      if (this.layoverCount === 2) {
        this.entryForm.controls['LayoverAirport2'].setValidators([Validators.required]);
        this.entryForm.controls['LayoverAirport2'].updateValueAndValidity();
      }
    }
  }
  removeLayover(): void {
    if (this.layoverCount > 0) {
      if (this.layoverCount === 2) {
        this.selectedLayoverAirport2 = null;
        this.entryForm.controls['LayoverAirport2'].setValue(null);
        this.entryForm.controls['LayoverAirport2'].clearValidators();
        this.entryForm.controls['LayoverAirport2'].updateValueAndValidity();
      } else if (this.layoverCount === 1) {
        this.selectedLayoverAirport1 = null;
        this.entryForm.controls['LayoverAirport1'].setValue(null);
        this.entryForm.controls['LayoverAirport1'].clearValidators();
        this.entryForm.controls['LayoverAirport1'].updateValueAndValidity();
      }
      this.layoverCount--;
      this.entryForm.controls['LayoverCount'].setValue(this.layoverCount);
    }
  }


  setConsultantHours(): void {
    if (
      this.entryForm.controls['Hours'].value ===
      Number(this.consultantWorkHour) / 2
    ) {
      this.entryForm.value.Hours = Number(this.consultantWorkHour) / 2;
    }
    else if (Number(this.entryForm.controls['Hours'].value) === Number(this.consultantWorkHour)) {
      this.entryForm.value.Hours = Number(this.consultantWorkHour);
    }
  }

  getExpenseType(client, project): void {
    this.expenseTypeList = [];
    if (!commonFunctions.isNullOrUndefined(client) && !commonFunctions.isNullOrUndefined(project) && client !== '') {
      this.expenseTypeService.getExpenseTypes(client, project).subscribe(expensetypes => {
        this.expenseTypeList = expensetypes;
        this.selectedExpenseType = this.expenseTypeList.filter(type => {
          return type.Type === this.dialogData.ExpenseType;
        })[0];
        if (!commonFunctions.isNullOrUndefined(this.selectedExpenseType)) {
          this.getExpenseTypeDesc(this.selectedExpenseType.Type);
        }
        if (commonFunctions.isNullOrUndefined(this.selectedExpenseType) && this.expenseTypeList.length === 1) {
          this.selectedExpenseType = this.expenseTypeList[0];
        }
      });
    }
  }
  checkLayovers(): void {
    const desc = this.selectedExpenseDescType?.description?.toLowerCase();

    if (desc === 'plane travel'
      && this.layoverCount === 2
      && this.selectedLayoverAirport1
      && this.selectedLayoverAirport2
      && this.selectedLayoverAirport1 === this.selectedLayoverAirport2) {

      this.snackBarService.showSnackBar(
        'Both layovers must be different!',
        'close',
        'failure'
      );

      // Reset second layover 
      this.selectedLayoverAirport2 = null;
      this.entryForm.get('LayoverAirport2')?.reset();
    }
  }

  getExpenseTypeDesc(expenseType): void {
    this.expenseTypeDescList = [];
    if (!commonFunctions.isNullOrUndefined(expenseType)) {
      this.expenseTypeService.getExpenseTypeDesc(expenseType).subscribe(expenseTypeDesc => {
        this.expenseTypeDescList = expenseTypeDesc;
        this.selectedExpenseDescType = this.expenseTypeDescList.filter(typedesc => {
          return typedesc.description === this.dialogData.Description;
        })[0];
        if (commonFunctions.isNullOrUndefined(this.selectedExpenseDescType) && this.expenseTypeDescList.length === 1) {
          this.selectedExpenseDescType = this.expenseTypeDescList[0];
        }

        // Check if the selected description is Plane Travel and handle accordingly
        if (this.selectedExpenseDescType && this.selectedExpenseDescType.description === 'Plane Travel') {
          this.getAirports();
        }
      });
    }
  }

  getPaymentMethod(): void {
    this.paymentMethodList = [];
    this.expensePaymentMethodService.getExpensePaymentMethod().subscribe(paymentMethod => {
      this.paymentMethodList = paymentMethod;
      this.selectedPaymentMethod = this.paymentMethodList.filter(method => {
        return method.value.toLowerCase() === this.dialogData.PaymentMethod.toLowerCase();
      })[0];
    });
  }

  getCurrency(client, project): void {
    this.currencyList = [];
    const consultantClientProjectRate = new ConsultantProjectRateParameterModel();

    if (typeof this.entryForm.value.TDate === 'object') {
      this.entryForm.value.TDate = DateUtility.formatStringfromDate(
        this.entryForm.value.TDate.toDate()
      );
    }

    const entryDate = DateUtility.createDateTypefromDate(
      this.entryForm.value.TDate.substr(0, 10)
    );

    consultantClientProjectRate.employee = this.currentUser.Employee;
    consultantClientProjectRate.client = client;
    consultantClientProjectRate.project = project;
    consultantClientProjectRate.entrydate = String(entryDate.getFullYear()) + String((Number(entryDate.getMonth()) + 1 < 10 ? '0' : '') + (Number(entryDate.getMonth()) + 1));
    this.currencyService.getCurrencyDetails().subscribe(currency => {
      this.currencyList = currency;
      this.consultantRateService.getConsultantByProject(consultantClientProjectRate).subscribe(consultantRate => {
        if (!commonFunctions.isNullOrUndefined(consultantRate[0])) {
          this.consulantProjectClientRate = consultantRate[0];
          this.selectedCurrency = this.currencyList.filter(selectedcurrency => {
            return selectedcurrency.currency_symbol_short === this.consulantProjectClientRate.Converted_Currency_Symbol;
          })[0];
          this.projectCurrency = this.selectedCurrency.currency_symbol_short;
        }
        if (!commonFunctions.isNullOrUndefined(this.dialogData.Currency_symbol_short) && this.dialogData.Currency_symbol_short !== '') {
          this.selectedCurrency = this.currencyList.filter(selectedcurrency => {
            return selectedcurrency.currency_symbol_short === this.dialogData.Currency_symbol_short;
          })[0];
        }
      });
    });
  }
  private updateVatFields(currencySymbolShort: string): void {

    if (this.selectedCurrency && this.selectedCurrency.currency_symbol) {
      const symbol = this.selectedCurrency.currency_symbol;
      const vatRate = this.VAT_RATES[symbol];
      this.showVatFields = vatRate !== undefined;

      if (this.showVatFields) {
        this.vatRate = vatRate;

        // Preserve existing values in edit mode
        if (this.dialogData.Mode === 'edit') {
          const currentTaxAmount = this.entryForm.get('Tax_Amount').value;
          if (currentTaxAmount) {
            this.entryForm.get('isVatApplicable').enable();
            this.entryForm.get('isVatApplicable').setValue(true);
            this.entryForm.get('Tax_Amount').enable();
            this.entryForm.get('Tax_Amount').setValue(currentTaxAmount);
            this.isVatManuallyEdited = true;
            return; // Exit early to prevent recalculation
          }
        }

        // Only proceed with normal calculation for new entries
        this.entryForm.get('isVatApplicable').enable();
        const currentAmount = this.entryForm.get('AmountSpent').value;
        if (currentAmount && this.entryForm.get('isVatApplicable').value) {
          this.calculateAndSetVat(currentAmount);
        }
      } else {
        this.vatRate = 0;
        if (this.dialogData.Mode !== 'edit') { // Fixed comparison
          this.entryForm.get('isVatApplicable').setValue(false);
          this.entryForm.get('Tax_Amount').setValue(null);
        }
        this.entryForm.get('isVatApplicable').disable();
      }
    }

  }
  setFormGroupValue(): void {

    this.entryForm.value.Task_Name = this.selectedProjectTask.Task_description;
    this.entryForm.value.Task_id = this.selectedProjectTask.Task_id;
    this.entryForm.value.Client = this.selectedProject.Client;
    this.entryForm.value.ClientName = this.selectedProject.ClientName;
    this.entryForm.value.ProjectName = this.selectedProject.Description;
    this.entryForm.value.Project = this.selectedProject.Project;


    if (typeof this.entryForm.value.TDate === 'object') {
      this.entryForm.value.TDate = DateUtility.formatStringfromDate(
        this.entryForm.value.TDate.toDate()
      );
    }

    if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      this.entryForm.value.Task_Code = this.selectedProjectTask.Task_name;
      this.entryForm.value.Rate = this.selectedConsultantRate.Converted_Rate;
      this.entryForm.value.Currency_Code =
        this.selectedConsultantRate.Converted_Currency_Code;
      this.entryForm.value.Currency_symbol_short =
        this.selectedConsultantRate.Converted_Currency_Symbol;
      this.entryForm.value.Charge = this.isChargeable ? 'YES' : 'NO';

      if (typeof this.entryForm.value.Invoice_Date === 'object') {
        this.entryForm.value.Invoice_Date = DateUtility.formatStringfromDate(
          this.entryForm.value.Invoice_Date.toDate()
        );
      }
      if (this.invoiceOnSameDate) {
        this.entryForm.value.Invoice_Date = this.entryForm.value.TDate;
      }
    } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
      const vatValues = {
        isVatApplicable: this.entryForm.get('isVatApplicable').value,
        taxAmount: this.entryForm.get('Tax_Amount').value
      };
      this.entryForm.value.Task_Description =
        this.selectedProjectTask.Task_name;
      this.entryForm.value.Project_Description =
        this.selectedProject.Description;
      this.entryForm.value.Currency_From = this.selectedCurrency.currency_code;
      this.entryForm.value.Currency_symbol =
        this.selectedCurrency.currency_symbol;
      this.entryForm.value.Currency_symbol_short =
        this.selectedCurrency.currency_symbol_short;
      this.entryForm.value.PaymentMethod = this.selectedPaymentMethod.value;
      this.entryForm.value.ExpenseType = this.selectedExpenseType.Type;
      this.entryForm.value.Description =
        this.selectedExpenseDescType.description;
        this.entryForm.value.isVatApplicable = vatValues.isVatApplicable;
        this.entryForm.value.Tax_Amount = vatValues.taxAmount;
      if (this.entryForm.value.Mileage > 0) {
        this.entryForm.value.Mileage = parseFloat(
          this.entryForm.value.Mileage
        ).toFixed(6);
      }
      if (this.entryForm.value.AmountSpent !== 0) {
        this.entryForm.value.AmountSpent = parseFloat(
          this.entryForm.value.AmountSpent
        ).toFixed(4);
      }
      this.entryForm.value.MileageRate = this.selectedProject.MileageRate;
      if (typeof this.entryForm.value.Invoice_date === 'object') {
        this.entryForm.value.Invoice_date = DateUtility.formatStringfromDate(
          this.entryForm.value.Invoice_date.toDate()
        );
      }
      this.entryForm.value.Description = this.selectedExpenseDescType.description;

      const rt = this.entryForm.get('RoundTrip')?.value === true;
      this.entryForm.value.is_roundtrip = rt ? 1 : 0;

      // --- Travel Specific Mapping ---
      if (this.selectedExpenseDescType.description === 'Plane Travel') {
        // Original expense fields
        this.entryForm.value.FromAirport = this.selectedFromAirport;
        this.entryForm.value.ToAirport = this.selectedToAirport;
        this.entryForm.value.LayoverAirport1 = this.selectedLayoverAirport1;
        this.entryForm.value.LayoverAirport2 = this.selectedLayoverAirport2;
        this.entryForm.value.LayoverCount = this.layoverCount;
        this.entryForm.value.RoundTrip = this.entryForm.get('RoundTrip')?.value || false;

        // Sustainability mapping
        this.entryForm.value.plane_origin = this.selectedFromAirport;
        this.entryForm.value.plane_destination = this.selectedToAirport;
        this.entryForm.value.travel_type = 'Plane Travel';
        this.entryForm.value.transport_mode_id = 15; // Plane ID
        // Also populate field used by header for sustainability save
        this.entryForm.value.transportModes = 'Plane';
        // Also include human-readable airport descriptions for sustainability
        const fromObj = this.airportList?.find(a => a.iata_code === this.selectedFromAirport);
        const toObj = this.airportList?.find(a => a.iata_code === this.selectedToAirport);
        if (fromObj) {
          this.entryForm.value.plane_origin_desc = fromObj.airport_desc || fromObj.name || this.selectedFromAirport;
        }
        if (toObj) {
          this.entryForm.value.plane_destination_desc = toObj.airport_desc || toObj.name || this.selectedToAirport;
        }
      } else if (
        this.selectedExpenseDescType.description === 'Mileage' ||
        this.selectedExpenseDescType.description === 'Motor Vehicle Hire' ||
        this.selectedExpenseDescType.description === 'Train Travel' ||
        this.selectedExpenseDescType.description === 'Train/Bus Travel' ||
        this.selectedExpenseDescType.description === 'Taxi Travel' ||
        this.selectedExpenseDescType.description === 'Taxi travel'
      ) {
        // Original expense fields
        this.entryForm.value.Distance =
          this.entryForm.get('Distance')?.value || 0;
        this.entryForm.value.DistanceUnit =
          this.entryForm.get('DistanceUnit')?.value || '';
        this.entryForm.value.TransportType =
          this.entryForm.get('TransportType')?.value || '';

        // Sustainability mapping
        this.entryForm.value.distance = this.entryForm.value.Distance;
        this.entryForm.value.distance_unit = this.entryForm.value.DistanceUnit;
        this.entryForm.value.travel_type =
          this.selectedExpenseDescType.description;

        // Fix: Look up the selected transport mode from filteredModes to get both ID and description
        const selectedTransportId = this.entryForm.get('TransportType')?.value;
        if (selectedTransportId != null && this.filteredModes.length > 0) {
          const selectedMode = this.filteredModes.find(mode => String(mode.transportmode_id) == String(selectedTransportId));
          if (selectedMode) {
            this.entryForm.value.transport_mode_id = selectedMode.transportmode_id;
            this.entryForm.value.transportmode_desc = selectedMode.transportmode_desc;
            // Also populate field used by header for sustainability save
            this.entryForm.value.transportModes = selectedMode.transportmode_desc;
          }
        } else {
          const isVehicle =
            this.selectedExpenseDescType.description === 'Mileage' ||
            this.selectedExpenseDescType.description === 'Motor Vehicle Hire';
          const isTaxi = this.selectedExpenseDescType.description === 'Taxi Travel'||
            this.selectedExpenseDescType.description === 'Taxi travel';
          // Fallback mapping: Taxi Travel -> id 12, vehicle types -> use id 1, train -> id 2
          if (isTaxi) {
            this.entryForm.value.transport_mode_id = 12;
            this.entryForm.value.transportmode_desc = 'Taxi';
            this.entryForm.value.transportModes = 'Taxi';
          } else {
            this.entryForm.value.transport_mode_id = isVehicle ? 1 : 2;
            this.entryForm.value.transportmode_desc = isVehicle ? 'Taxi' : 'Train';
            this.entryForm.value.transportModes = isVehicle ? 'Taxi' : 'Train';
          }

        }
      }

      // --- Other expense fields ---
      // if (this.entryForm.value.Mileage > 0) {
      //    this.entryForm.value.Mileage = parseFloat(
      //      this.entryForm.value.Mileage
      //    ).toFixed(6);
      // }
      if (this.entryForm.value.AmountSpent !== 0) {
        this.entryForm.value.AmountSpent = parseFloat(
          this.entryForm.value.AmountSpent
        ).toFixed(4);
      }
      this.entryForm.value.MileageRate = this.selectedProject.MileageRate;

      if (typeof this.entryForm.value.Invoice_date === 'object') {
        this.entryForm.value.Invoice_date = DateUtility.formatStringfromDate(
          this.entryForm.value.Invoice_date.toDate()
        );
      }
      if (this.invoiceOnSameDate) {
        this.entryForm.value.Invoice_date = this.entryForm.value.TDate;
      }
    }
  }



  save(): void {

    const layoversValid = () => {
      const desc = this.selectedExpenseDescType?.description;
      if (desc === 'Plane Travel' && this.layoverCount === 2) {
        return this.selectedLayoverAirport1 !== this.selectedLayoverAirport2;
      }
      return true;
    };

    if (!layoversValid()) {
      this.snackBarService.showSnackBar('Both layovers must be different!', 'close', 'failure');
      return; // stop saving
    }
    // --- End layover block ---

    this.entryForm.value.Copy = false;

    // --- Map transport mode IDs ---
    const desc = this.selectedExpenseDescType?.description;
    if (desc === 'Plane Travel') {
      this.entryForm.value.transport_mode_id = 15;
      this.entryForm.value.transportmode_desc = 'Plane';
      this.entryForm.value.transportModes = 'Plane';
    }

    // --- Continue with existing entry logic ---
    if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
      this.setConsultantHours();
      if (this.entryForm.value.Hours > 0 && this.entryForm.value.Hours <= 24) {
        this.setFormGroupValue();

        // --- Add Sustainability Fields ---
        const currentUser = this.currentUser;
        const tDate = new Date(this.entryForm.value.TDate);
        this.entryForm.value.travel_id = this.dialogData?.travel_id || 0;
        this.entryForm.value.login_name = currentUser?.LoginName
          ;
        this.entryForm.value.month = tDate.getMonth() + 1;
        this.entryForm.value.year = tDate.getFullYear();

        this.entryForm.value.__hasDialogEdits = true;
        this.dialogRef.close(this.entryForm.value);
      } else {
        this.snackBarService.showSnackBar(
          Constants.SNACKBAR_MSG_TIME_ENTRY_VALID_HOURS,
          'close',
          'failure'
        );
      }
    } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
      if (
        !commonFunctions.isNullOrUndefined(this.selectedExpenseDescType)
        // &&
        // this.selectedExpenseDescType.description !== 'Mileage'
      ) {
        // --- Map Taxi/Train/Vehicle fields ---
        if (desc === 'Mileage' || desc === 'Motor Vehicle Hire' || desc === 'Train Travel' || desc === 'Train/Bus Travel' || desc === 'Taxi Travel' || desc === 'Taxi travel') {
          this.entryForm.value.Distance = this.entryForm.get('Distance')?.value;
          this.entryForm.value.DistanceUnit = this.entryForm.get('DistanceUnit')?.value;
          this.entryForm.value.TransportType = this.entryForm.get('TransportType')?.value;

          // Ensure is_roundtrip is 0 for non-plane travel
          this.entryForm.value.is_roundtrip = 0;

          // Fix: Look up selected transport mode for ID + description
          const selectedTransportId = this.entryForm.get('TransportType')?.value;
          if (selectedTransportId && this.filteredModes.length > 0) {
            const selectedMode = this.filteredModes.find(
              mode => String(mode.transportmode_id) === String(selectedTransportId)
            );

            if (selectedMode) {
              this.entryForm.value.transport_mode_id = selectedMode.transportmode_id;
              this.entryForm.value.transportmode_desc = selectedMode.transportmode_desc;
              this.entryForm.value.transportModes = selectedMode.transportmode_desc;

            }
          }

          // Map Period Month & Year
          if (!this.entryForm.get('Period_Month')?.value || !this.entryForm.get('Period_Year')?.value) {
            const tDate = new Date(this.entryForm.value.TDate);
            this.entryForm.value.Period_Month = tDate.getMonth() + 1;
            this.entryForm.value.Period_Year = tDate.getFullYear();
          }
        }

        // --- Map Plane fields ---
        if (desc === 'Plane Travel') {
          // Sustainability mapping
          const isToggleOn = this.entryForm.get('RoundTrip')?.value === true;
          this.entryForm.value.is_roundtrip = isToggleOn ? 1 : 0;

          this.entryForm.value.FromAirport = this.entryForm.get('FromAirport')?.value;
          this.entryForm.value.ToAirport = this.entryForm.get('ToAirport')?.value;
          this.entryForm.value.LayoverAirport1 = this.entryForm.get('LayoverAirport1')?.value;
          this.entryForm.value.LayoverAirport2 = this.entryForm.get('LayoverAirport2')?.value;
          this.entryForm.value.LayoverCount = this.entryForm.get('LayoverCount')?.value;
        }

        this.setFormGroupValue();
        // this.entryForm.value.Mileage = 0;

        // --- Add Sustainability Fields ---
        const currentUser = this.currentUser;
        const tDate = new Date(this.entryForm.value.TDate);
        this.entryForm.value.travel_id = this.dialogData?.travel_id || 0;
        this.entryForm.value.login_name = currentUser?.LoginName;
        this.entryForm.value.month = tDate.getMonth() + 1;
        this.entryForm.value.year = tDate.getFullYear();
        delete this.entryForm.value.Mileage;
        delete this.entryForm.value.mileage;

        this.entryForm.value.__hasDialogEdits = true;
        this.dialogRef.close(this.entryForm.value);
      } else {
        if (this.entryForm.value.Mileage > 0) {
          this.setFormGroupValue();

          // --- Add Sustainability Fields ---
          const currentUser = this.currentUser;
          const tDate = new Date(this.entryForm.value.TDate);
          this.entryForm.value.travel_id = this.dialogData?.travel_id || 0;
          this.entryForm.value.login_name = currentUser?.LoginName;
          this.entryForm.value.month = tDate.getMonth() + 1;
          this.entryForm.value.year = tDate.getFullYear();

          this.entryForm.value.__hasDialogEdits = true;
          this.dialogRef.close(this.entryForm.value);
        } else {
          this.snackBarService.showSnackBar(
            Constants.SNACKBAR_MSG_EXPENSE_ENTRY_VALID_MILEAGE,
            'close',
            'failure'
          );
        }
      }
    }
  }


  // cloneData(): void {
  //   this.entryForm.value.Copy = true;
  //   if (this.dialogData.entryPageType == Constants.NAV_TIME_ENTRY_ACTUALS) {
  //     this.entryForm.value.Time_ID = 0;
  //     this.setConsultantHours();
  //     this.setFormGroupValue();
  //     this.dialogRef.close(this.entryForm.value);
  //   } else if (this.dialogData.entryPageType == Constants.NAV_EXPENSE_ENTRY) {
  //     this.entryForm.value.ExpenseID = 0;
  //     if (!commonFunctions.isNullOrUndefined(this.selectedExpenseDescType) && this.selectedExpenseDescType.description !== 'Mileage') {
  //       this.setFormGroupValue();
  //       this.dialogRef.close(this.entryForm.value);
  //     }
  //     else {
  //       if (this.entryForm.value.Mileage > 0) {
  //         this.setFormGroupValue();
  //         this.dialogRef.close(this.entryForm.value);
  //       }
  //       else {
  //         this.snackBarService.showSnackBar('Please enter valid mileage', 'close', 'failure');
  //       }
  //     }
  //   }
  // }
  cloneData(): void {
    // Mark this payload as a clone
    this.entryForm.value.Copy = true;

    // IMPORTANT: always map/normalize form values before closing
    // (so the returned object matches what Save returns)
    this.setFormGroupValue();

    // ---- HARD RESET (works for saved + unsaved rows) ----
    // sustainability identity MUST NOT be carried to clone
    this.entryForm.value.travel_id = 0;
    this.entryForm.value.carbon_emission = null;

    // invoice identity MUST NOT be carried
    this.entryForm.value.Invoice_id = 0;

    // status: cloned row is always a new row
    this.entryForm.value.status = 'create';

    if (this.dialogData.entryPageType === Constants.NAV_TIME_ENTRY_ACTUALS) {
      // reset time PK
      this.entryForm.value.Time_ID = 0; // or null, depending on backend expectation

      // ensure invoice date aligns to TDate
      this.setConsultantHours();
      if (this.invoiceOnSameDate) {
        this.entryForm.value.Invoice_Date = this.entryForm.value.TDate;
      }

      this.dialogRef.close(this.entryForm.value);
      return;
    }

    if (this.dialogData.entryPageType === Constants.NAV_EXPENSE_ENTRY) {
      // reset expense PK
      this.entryForm.value.ExpenseID = 0; // or null, depending on backend expectation

      // ensure invoice date aligns to TDate
      if (this.invoiceOnSameDate) {
        this.entryForm.value.Invoice_date = this.entryForm.value.TDate;
      }

      // IMPORTANT: mileage fields are being deleted in save() branch,
      // do the same here so clone matches save behavior
      delete this.entryForm.value.Mileage;
      delete this.entryForm.value.mileage;

      this.dialogRef.close(this.entryForm.value);
      return;
    }
  }


  searchFunctionDropdown(term: string, item): any {
    const clientName = item['ClientName'].toLowerCase();
    const description = item['Description'].toLowerCase();
    const client = item['Client'].toLowerCase();
    const project = item['Project'].toLowerCase();
    const searchTerm = term.toLowerCase().split(' ');
    let found = 0;

    for (const key of searchTerm) {
      if (
        description.includes(key) ||
        clientName.includes(key) ||
        project.includes(key) ||
        client.includes(key.toLowerCase())
      ) {
        found = 1;
      } else {
        found = 0;
        break;
      }
    }
    return found;
  }

  searchDropDownProjectTask(term: string, item): any {
    const taskName = item['Task_name'].toLowerCase();
    const taskDescription = item['Task_description'].toLowerCase();
    const searchterm = term.toLowerCase().split(' ');
    let found = 0;
    for (const values of searchterm) {
      if (taskName.includes(values) || taskDescription.includes(values)) {
        found = 1;
      } else {
        found = 0;
      }
    }
    return found;
  }

  searchDropDownType(term: string, item): any {
    const type = item['Type'].toLowerCase();
    if (type.includes(term.toLowerCase())) {
      return 1;
    } else {
      return 0;
    }
  }

  searchDropDownTypeDesc(term: string, item): any {
    const description = item['description'].toLowerCase();
    if (description.includes(term.toLowerCase())) {
      return 1;
    } else {
      return 0;
    }
  }
  private currencyHasVat(currencySymbol: string): boolean {
    return Object.keys(this.VAT_RATES).includes(currencySymbol);
  }
  onVatCheckboxChange(event: any): void {

    if (event.checked) {
      this.entryForm.get('Tax_Amount').enable();
      this.isVatManuallyEdited = false;
      this.calculateAndSetVat(this.entryForm.get('AmountSpent').value);
    } else {
      this.entryForm.get('Tax_Amount').disable();
      this.entryForm.get('Tax_Amount').setValue(null);
    }

  }

  // New search function for airports
  searchDropDownAirport(term: string, item): any {
    const iataCode = item['iata_code']?.toLowerCase() || '';
    const name = item['name']?.toLowerCase() || '';
    const airportDesc = item['airport_desc']?.toLowerCase() || '';
    const searchTerm = term.toLowerCase();

    if (iataCode.includes(searchTerm) || name.includes(searchTerm) ||
      airportDesc.includes(searchTerm)) {
      return 1;
    }
    return 0;
  }
}